import { formatPrice } from '../utils/formatPrice';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { API } from '../context/AuthContext';
import PortfolioChart from '../components/PortfolioChart';
import NavBar from "../components/NavBar";

export default function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [portfolio, setPortfolio] = useState(null);
  const [exitLadder, setExitLadder] = useState([]);
  const [aiQuestion, setAiQuestion] = useState('');
  const [aiAnswer, setAiAnswer] = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const [aiUsed, setAiUsed] = useState(0);
  const [aiLimit, setAiLimit] = useState(10);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('portfolio');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [upgrading, setUpgrading] = useState(false);
  const [callBooked, setCallBooked] = useState(false);
  const [billingCycle, setBillingCycle] = useState('monthly');
  const [reactivating, setReactivating] = useState(false);
  const [showWizard, setShowWizard] = useState(false);
  const [wizard, setWizard] = useState({ coin_symbol: "XRP", low_target: "", high_target: "", moon_bag_pct: "20", style: "balanced" });
  const [wizardSaving, setWizardSaving] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const reactivate = params.get('reactivate');
    const coupon = params.get('coupon');
    if (params.get('call_booked')) { setCallBooked(true); window.history.replaceState({}, '', '/dashboard'); }
    if (reactivate === 'monthly' || reactivate === 'yearly') {
      setReactivating(true);
      window.history.replaceState({}, '', '/dashboard');
      axios.post(`${API}/api/stripe/create-checkout`, { tier: 'premium', billing: reactivate, couponCode: coupon || null })
        .then(res => { window.location.href = res.data.url; })
        .catch(err => { console.error('Reactivate error:', err); setReactivating(false); loadDashboard(); });
      return;
    }
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      const [portfolioRes, ladderRes, userRes] = await Promise.all([
        axios.get(`${API}/api/prices/portfolio`),
        axios.get(`${API}/api/exit-ladder`),
        axios.get(`${API}/api/auth/me`)
      ]);
      setPortfolio(portfolioRes.data);
      setExitLadder(ladderRes.data.ladders);
      setAiUsed(userRes.data.user.ai_questions_used || 0);
      const tier = userRes.data.user.subscription_tier;
      setAiLimit(10);
      setPortfolio(portfolioRes.data);
      setExitLadder(ladderRes.data.ladders);
      if (portfolioRes.data.holdings.length === 0 && ladderRes.data.ladders.length === 0) {
        const params = new URLSearchParams(window.location.search);
        if (!params.get('upgraded') && !params.get('cancelled') && !params.get('from')) {
          navigate('/onboarding');
        }
      }
    } catch (err) {
      console.error('Dashboard load error:', err);
    } finally {
      setLoading(false);
    }
  };
  const generateExitPlan = () => {
    const low = parseFloat(wizard.low_target);
    const high = parseFloat(wizard.high_target);
    const moonBag = parseFloat(wizard.moon_bag_pct) || 20;
    if (!low || !high || low >= high) return [];
    const sellable = 100 - moonBag;
    const rungs = [];
    if (wizard.style === "conservative") {
      rungs.push({ pct: Math.round(sellable * 0.15), price: (low).toFixed(2) });
      rungs.push({ pct: Math.round(sellable * 0.20), price: (low + (high - low) * 0.33).toFixed(2) });
      rungs.push({ pct: Math.round(sellable * 0.25), price: (low + (high - low) * 0.66).toFixed(2) });
      rungs.push({ pct: Math.round(sellable * 0.40), price: high.toFixed(2) });
    } else if (wizard.style === "aggressive") {
      rungs.push({ pct: Math.round(sellable * 0.10), price: (low).toFixed(2) });
      rungs.push({ pct: Math.round(sellable * 0.15), price: (low + (high - low) * 0.33).toFixed(2) });
      rungs.push({ pct: Math.round(sellable * 0.25), price: (low + (high - low) * 0.66).toFixed(2) });
      rungs.push({ pct: Math.round(sellable * 0.50), price: high.toFixed(2) });
    } else {
      rungs.push({ pct: Math.round(sellable * 0.15), price: (low).toFixed(2) });
      rungs.push({ pct: Math.round(sellable * 0.20), price: (low + (high - low) * 0.25).toFixed(2) });
      rungs.push({ pct: Math.round(sellable * 0.25), price: (low + (high - low) * 0.50).toFixed(2) });
      rungs.push({ pct: Math.round(sellable * 0.40), price: high.toFixed(2) });
    }
    return rungs;
  };
  const saveExitPlan = async () => {
    const rungs = generateExitPlan();
    if (rungs.length === 0) return;
    setWizardSaving(true);
    try {
      const existing = exitLadder.filter(r => r.coin_symbol === wizard.coin_symbol);
      for (const r of existing) {
        await axios.delete(`${API}/api/exit-ladder/${r.id}`);
      }
      for (const rung of rungs) {
        await axios.post(`${API}/api/exit-ladder`, { coin_symbol: wizard.coin_symbol, target_price: rung.price, sell_percentage: rung.pct, is_moon_bag: false });
      }
      if (parseFloat(wizard.moon_bag_pct) > 0) {
        await axios.post(`${API}/api/exit-ladder`, { coin_symbol: wizard.coin_symbol, target_price: wizard.high_target, sell_percentage: wizard.moon_bag_pct, is_moon_bag: true });
      }
      const res = await axios.get(`${API}/api/exit-ladder`);
      setExitLadder(res.data.ladders);
      setShowWizard(false);
      setWizard({ coin_symbol: "XRP", low_target: "", high_target: "", moon_bag_pct: "20", style: "balanced" });
    } catch (err) { console.error("Save exit plan error:", err); }
    finally { setWizardSaving(false); }
  };

  const askAI = async () => {
    if (!aiQuestion.trim()) return;
    setAiLoading(true);
    setAiAnswer('');
    try {
      const res = await axios.post(`${API}/api/ai/ask`, { question: aiQuestion });
      setAiAnswer(res.data.answer);
      setAiUsed(res.data.questions_used);
      setAiLimit(user?.subscription_10);
    } catch (err) {
      if (err.response?.status === 403) {
        setAiAnswer('Please upgrade to Premium to use the AI advisor.');
      } else if (err.response?.status === 429) {
        setAiAnswer(err.response.data.error);
      } else {
        setAiAnswer('Something went wrong. Please try again.');
      }
    } finally {
      setAiLoading(false);
    }
  };

  const handleUpgrade = async (tier, billing = 'monthly') => {
    setUpgrading(true);
    try {
      const res = await axios.post(`${API}/api/stripe/create-checkout`, { tier, billing });
      window.location.href = res.data.url;
    } catch (err) {
      console.error('Upgrade error:', err);
      setUpgrading(false);
    }
  };

  const fmt = (n) => '$' + Math.round(n || 0).toLocaleString();
  const fmtPct = (n) => (n >= 0 ? '+' : '') + (n || 0).toFixed(1) + '%';

  if (reactivating) return (<div style={{minHeight:'100vh', background:'#f4f1eb', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'system-ui, sans-serif'}}><p style={{color:'#6b6b6b'}}>Redirecting to checkout...</p></div>);
  if (loading) return (
    <div style={styles.loadingPage}>
      <div style={styles.loadingText}>Loading your dashboard...</div>
    </div>
  );

  const summary = portfolio?.summary;
  const holdings = portfolio?.holdings || [];

  return (
    <div style={styles.page}>
      <style>{`
        @media (max-width: 768px) {
          .dash-metrics { grid-template-columns: 1fr 1fr !important; }
          .dash-content { padding: 1rem !important; }
          .dash-nav { padding: 0 1rem !important; }
          .dash-nav-user { display: none !important; }
      `}</style>
      <NavBar />

      <div className="dash-content" style={styles.content}>

        {callBooked && (
          <div style={{background:'#e8f5ef', border:'1px solid rgba(26,107,74,0.3)', borderRadius:'12px', padding:'1rem 1.25rem', marginBottom:'1.5rem', display:'flex', alignItems:'center', gap:'12px'}}>
            <span style={{fontSize:'20px'}}>✓</span>
            <div>
              <div style={{fontWeight:'500', color:'#1a6b4a', marginBottom:'2px'}}>Payment confirmed — you're all set!</div>
              <div style={{fontSize:'14px', color:'#6b6b6b'}}>Check your email for your Calendly link to book your 30-minute portfolio strategy call.</div>
            </div>
            <button onClick={() => setCallBooked(false)} style={{marginLeft:'auto', background:'none', border:'none', color:'#6b6b6b', cursor:'pointer', fontSize:'18px'}}>×</button>
          </div>
        )}

        <div className="dash-metrics" style={styles.metrics}>
          <div style={styles.metric}>
            <div style={styles.metricLabel}>Total value</div>
            <div style={styles.metricValue}>{fmt(summary?.total_value)}</div>
            <div style={styles.metricSub}>Current portfolio</div>
          </div>
          <div style={styles.metric}>
            <div style={styles.metricLabel}>Total gain</div>
            <div style={{ ...styles.metricValue, color: summary?.total_gain >= 0 ? '#1a6b4a' : '#dc2626' }}>
              {fmt(summary?.total_gain)}
            </div>
            <div style={styles.metricSub}>{fmtPct(summary?.total_gain_percent)}</div>
          </div>
          <div style={styles.metric}>
            <div style={styles.metricLabel}>Cost basis</div>
            <div style={styles.metricValue}>{fmt(summary?.total_cost)}</div>
            <div style={styles.metricSub}>Total invested</div>
          </div>
          <div style={styles.metric}>
            <div style={styles.metricLabel}>Exit targets</div>
            <div style={styles.metricValue}>{exitLadder.length}</div>
            <div style={styles.metricSub}>Rungs set</div>
          </div>
        </div>

        <PortfolioChart currentValue={summary?.total_value || 0} holdings={holdings} />
        <div style={styles.tabs}>
          {['portfolio', 'exit', 'ai'].map(tab => (
            <button key={tab} onClick={() => setActiveTab(tab)}
              style={{ ...styles.tab, ...(activeTab === tab ? styles.tabActive : {}) }}>
              {tab === 'portfolio' ? 'Holdings' : tab === 'exit' ? 'Exit ladder' : 'AI advisor'}
            </button>
          ))}
        </div>

        {activeTab === 'portfolio' && (
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>Your holdings</h2>
              <a href="/settings" style={styles.addBtn}>+ Add holdings</a>
            </div>
            {holdings.length === 0 ? (
              <p style={styles.empty}>No holdings yet. <a href="/onboarding" style={styles.link}>Set up your portfolio</a></p>
            ) : Object.values(holdings.reduce((acc, h) => {
                const sym = h.coin_symbol;
                if (!acc[sym]) acc[sym] = { coin_symbol: sym, total_amount: 0, total_value: 0, total_gain: 0, total_cost: 0 };
                acc[sym].total_amount += parseFloat(h.amount);
                acc[sym].current_price = h.current_price || 0;
                acc[sym].total_value += h.current_value || 0;
                acc[sym].total_gain += h.unrealized_gain || 0;
                acc[sym].total_cost += h.cost_basis || 0;
                return acc;
              }, {})).sort((a, b) => a.coin_symbol.localeCompare(b.coin_symbol)).map(g => (
              <div key={g.coin_symbol} style={styles.holdingRow}>
                <div style={styles.holdingLeft}>
                  <div style={styles.coinBadge}>{g.coin_symbol}</div>
                  <div>
                    <div style={styles.holdingName}>{g.coin_symbol}</div>
                    <div style={styles.holdingDetail}>{Math.round(g.total_amount).toLocaleString()} coins · DCA: ${g.total_cost > 0 && g.total_amount > 0 ? formatPrice(g.total_cost / g.total_amount) : "—"}</div>
                  </div>
                </div>
                <div style={styles.holdingRight}>
                  <div style={styles.holdingValue}>{fmt(g.total_value)}</div>
                  <div style={{ ...styles.holdingGain, color: g.total_gain >= 0 ? "#1a6b4a" : "#dc2626" }}>
                    {fmt(g.total_gain)} ({fmtPct(g.total_cost > 0 ? (g.total_gain/g.total_cost)*100 : 0)})
                  </div>
                  {g.current_price > 0 && <div style={{fontSize:"12px", color:"#6b6b6b", marginTop:"2px"}}>Current: ${formatPrice(g.current_price)}</div>}
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'exit' && (
          <div style={styles.section}>
            <div style={styles.sectionHeader}>
              <h2 style={styles.sectionTitle}>Exit ladder</h2>
              <a href="/settings#exit" style={styles.addBtn}>+ Add targets</a>
              <button onClick={() => { setWizardSaving(false); setShowWizard(true); }} style={{...styles.addBtn, background:"#1a6b4a", color:"#fff", border:"none", borderRadius:"6px", padding:"4px 10px", cursor:"pointer", fontSize:"13px", marginLeft:"8px"}}>Build exit plan</button>
            </div>
            {exitLadder.length === 0 ? (
              <p style={styles.empty}>No exit targets set. <a href="/onboarding" style={styles.link}>Set up your exit plan</a></p>
            ) : Object.entries(
                exitLadder.reduce((acc, r) => {
                  if (!acc[r.coin_symbol]) acc[r.coin_symbol] = [];
                  acc[r.coin_symbol].push(r);
                  return acc;
                }, {})
              ).sort(([a], [b]) => a.localeCompare(b)).map(([symbol, rungs]) => {
                const holding = holdings.find(h => h.coin_symbol === symbol);
                const currentPrice = holding?.current_price || 0;
                const sortedRungs = [...rungs].sort((a, b) => { if (a.is_moon_bag) return 1; if (b.is_moon_bag) return -1; return parseFloat(a.target_price) - parseFloat(b.target_price); });
                return (
                  <div key={symbol} style={{marginBottom:"1.5rem"}}>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"0.75rem"}}>
                      <div style={{display:"flex", alignItems:"center", gap:"8px"}}>
                        <div style={styles.coinBadge}>{symbol}</div>
                        {currentPrice > 0 && <span style={{fontSize:"13px", color:"#6b6b6b"}}>Current: ${formatPrice(currentPrice)}</span>}
                      </div>
                      <button onClick={() => { setWizardSaving(false); setWizard({ coin_symbol: symbol, low_target: "", high_target: "", moon_bag_pct: "20", style: "balanced" }); setShowWizard(true); }} style={{fontSize:"12px", color:"#1a6b4a", background:"transparent", border:"1px solid rgba(26,107,74,0.3)", borderRadius:"6px", padding:"4px 10px", cursor:"pointer"}}>Edit plan</button>
                    </div>
                    {sortedRungs.map(rung => {
                      const progress = rung.is_moon_bag ? 100 : Math.min((currentPrice / parseFloat(rung.target_price)) * 100, 100);
                      return (
                        <div key={rung.id} style={{...styles.exitRow, marginLeft:"8px", borderLeft:"2px solid " + (rung.is_moon_bag ? "#f59e0b" : "#1a6b4a"), paddingLeft:"12px", marginBottom:"8px"}}>
                          <div style={styles.exitHeader}>
                            <span style={styles.exitLabel}>
                              {rung.is_moon_bag ? "Hold as moon bag — " + rung.sell_percentage + "%" : "Sell " + rung.sell_percentage + "% at $" + parseFloat(rung.target_price).toFixed(2)}
                            </span>
                            {!rung.is_moon_bag && <span style={styles.exitPct}>{Math.round(progress)}% there</span>}
                          </div>
                          {!rung.is_moon_bag && (
                            <div style={styles.progressBar}>
                              <div style={{...styles.progressFill, width: progress + "%"}} />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
          </div>
        )}

        {activeTab === 'ai' && (
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>AI wealth advisor</h2>
            {user?.subscription_tier === 'free' ? (
              <div style={styles.upgradeBox}>
                <p style={styles.upgradeText}>The AI advisor is available on Premium and Elite plans.</p>
                <div style={{display:'flex', flexDirection:'column', alignItems:'center', gap:'12px'}}>
                  <div style={{display:'flex', gap:'6px', fontSize:'13px'}}>
                    <button onClick={() => setBillingCycle('monthly')} style={{padding:'6px 14px', borderRadius:'6px', border:'1px solid rgba(26,107,74,0.4)', background: billingCycle==='monthly' ? '#1a6b4a' : 'transparent', color: billingCycle==='monthly' ? '#fff' : '#1a6b4a', cursor:'pointer', fontSize:'13px'}}>Monthly — $27</button>
                    <button onClick={() => setBillingCycle('yearly')} style={{padding:'6px 14px', borderRadius:'6px', border:'1px solid rgba(26,107,74,0.4)', background: billingCycle==='yearly' ? '#1a6b4a' : 'transparent', color: billingCycle==='yearly' ? '#fff' : '#1a6b4a', cursor:'pointer', fontSize:'13px'}}>Yearly — $270 <span style={{fontWeight:'600', color: billingCycle==='yearly' ? '#a8f0c6' : '#1a6b4a'}}>2 months free</span></button>
                  </div>
                  <button onClick={() => handleUpgrade('premium', billingCycle)} style={styles.upgradeBtn} disabled={upgrading}>
                    {upgrading ? 'Redirecting...' : billingCycle === 'yearly' ? 'Upgrade to Pro — $270/yr' : 'Upgrade to Pro — $27/mo'}
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <p style={styles.aiNote}>Ask anything about your portfolio, taxes, or exit strategy. {aiUsed}/{aiLimit} questions used this month.</p>
                <div style={styles.aiSuggestions}>
                  {['Can I retire if XRP hits $20?', 'How do I reduce my tax bill?', 'Should I sell in stages or all at once?'].map(q => (
                    <button key={q} onClick={() => setAiQuestion(q)} style={styles.suggestion}>{q}</button>
                  ))}
                </div>
                <textarea
                  value={aiQuestion}
                  onChange={e => setAiQuestion(e.target.value)}
                  style={styles.aiInput}
                  placeholder="Ask your AI wealth advisor anything..."
                  rows={3}
                />
                <button onClick={askAI} style={styles.btn} disabled={aiLoading}>
                  {aiLoading ? 'Thinking...' : 'Ask advisor'}
                </button>
                {aiAnswer && (
                  <div style={styles.aiAnswer}>
                    <div style={styles.aiAnswerLabel}>AI Advisor</div>
                    <p style={styles.aiAnswerText}>{aiAnswer.split("**").map((part, i) => i % 2 === 0 ? part : part).join("").replace(/#{1,3} /g, "").replace(/^- /gm, "• ")}</p>
                    <p style={styles.aiDisclaimer}>This is not financial or tax advice. Consult a licensed professional before making decisions.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
      <div style={{background:'#fff', borderRadius:'16px', padding:'1.5rem', border:'1px solid rgba(26,107,74,0.2)', boxShadow:'0 1px 4px rgba(0,0,0,0.07)', marginTop:'1.5rem'}}>
        <div style={{display:'flex', alignItems:'flex-start', justifyContent:'space-between', flexDirection: window.innerWidth < 600 ? 'column' : 'row', flexWrap:'wrap', gap:'1rem'}}>
          <div style={{flex:1}}>
            <div style={{fontSize:'11px', fontWeight:'600', color:'#1a6b4a', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'0.4rem'}}>Exclusive for Pro Members</div>
            <h3 style={{fontSize:'18px', fontWeight:'500', color:'#1a1a1a', margin:'0 0 0.4rem'}}>1-on-1 Portfolio Strategy Call</h3>
            <p style={{fontSize:'14px', color:'#6b6b6b', lineHeight:'1.6', margin:'0 0 0.75rem'}}>Get expert eyes on your crypto portfolio. We'll review your holdings, exit strategy, and tax situation together — and build an action plan specific to your goals.</p>
            <div style={{display:'flex', alignItems:'center', gap:'12px', flexWrap:'wrap'}}>
              <span style={{fontSize:'24px', fontWeight:'600', color:'#1a1a1a'}}>$199</span>
              <span style={{fontSize:'14px', color:'#9b9b9b', textDecoration:'line-through'}}>$347</span>
              <span style={{background:'#e8f5ef', color:'#1a6b4a', fontSize:'12px', fontWeight:'600', padding:'3px 10px', borderRadius:'99px'}}>Limited spots</span>
            </div>
          </div>
          <button onClick={async () => {
            try {
              const res = await axios.post(`${API}/api/stripe/buy-call`, {});
              if (res.data.url) window.location.href = res.data.url;
            } catch(err) {
              alert(err.response?.data?.error || 'Something went wrong. Please try again.');
            }
          }} style={{background:'#1a6b4a', color:'#fff', border:'none', borderRadius:'10px', padding:'14px 24px', fontSize:'15px', fontWeight:'500', cursor:'pointer', width: window.innerWidth < 600 ? '100%' : 'auto', alignSelf:'center'}}>Book my call — $199</button>
        </div>
      </div>
      {showWizard && (
        <div style={{position:"fixed", top:0, left:0, right:0, bottom:0, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000, padding:"1rem"}} onClick={() => setShowWizard(false)}>
          <div style={{background:"#fff", borderRadius:"16px", padding:"2rem", width:"100%", maxWidth:"520px", maxHeight:"90vh", overflowY:"auto"}} onClick={e => e.stopPropagation()}>
            <h2 style={{fontSize:"20px", fontWeight:"500", color:"#1a1a1a", marginBottom:"0.5rem"}}>Build your exit plan</h2>
            <p style={{fontSize:"14px", color:"#6b6b6b", marginBottom:"1.5rem"}}>Enter your price targets and we will generate a smart sell ladder for you.</p>
            <div style={{display:"flex", flexDirection:"column", gap:"1rem"}}>
              <div><label style={{fontSize:"12px", fontWeight:"500", color:"#6b6b6b", textTransform:"uppercase", letterSpacing:"0.04em", display:"block", marginBottom:"6px"}}>Coin</label>
                <input style={{width:"100%", padding:"10px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:"8px", fontSize:"14px", boxSizing:"border-box"}} value={wizard.coin_symbol} onChange={e => setWizard({...wizard, coin_symbol: e.target.value.toUpperCase()})} placeholder="XRP" /></div>
              <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px"}}>
                <div><label style={{fontSize:"12px", fontWeight:"500", color:"#6b6b6b", textTransform:"uppercase", letterSpacing:"0.04em", display:"block", marginBottom:"6px"}}>Low target ($)</label>
                  <input style={{width:"100%", padding:"10px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:"8px", fontSize:"14px", boxSizing:"border-box"}} type="number" value={wizard.low_target} onChange={e => setWizard({...wizard, low_target: e.target.value})} placeholder="5.00" /></div>
                <div><label style={{fontSize:"12px", fontWeight:"500", color:"#6b6b6b", textTransform:"uppercase", letterSpacing:"0.04em", display:"block", marginBottom:"6px"}}>High target ($)</label>
                  <input style={{width:"100%", padding:"10px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:"8px", fontSize:"14px", boxSizing:"border-box"}} type="number" value={wizard.high_target} onChange={e => setWizard({...wizard, high_target: e.target.value})} placeholder="10.00" /></div>
              </div>
              <div style={{display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px"}}>
                <div><label style={{fontSize:"12px", fontWeight:"500", color:"#6b6b6b", textTransform:"uppercase", letterSpacing:"0.04em", display:"block", marginBottom:"6px"}}>Moon bag %</label>
                  <input style={{width:"100%", padding:"10px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:"8px", fontSize:"14px", boxSizing:"border-box"}} type="number" value={wizard.moon_bag_pct} onChange={e => setWizard({...wizard, moon_bag_pct: e.target.value})} placeholder="20" /></div>
                <div><label style={{fontSize:"12px", fontWeight:"500", color:"#6b6b6b", textTransform:"uppercase", letterSpacing:"0.04em", display:"block", marginBottom:"6px"}}>Strategy</label>
                  <select style={{width:"100%", padding:"10px 14px", border:"1px solid rgba(0,0,0,0.12)", borderRadius:"8px", fontSize:"14px", background:"#fff", boxSizing:"border-box"}} value={wizard.style} onChange={e => setWizard({...wizard, style: e.target.value})}>
                    <option value="conservative">Conservative — sell early</option>
                    <option value="balanced">Balanced — spread evenly</option>
                    <option value="aggressive">Aggressive — hold longer</option>
                  </select></div>
              </div>
              {wizard.low_target && wizard.high_target && parseFloat(wizard.low_target) < parseFloat(wizard.high_target) && (
                <div style={{background:"#f4f1eb", borderRadius:"12px", padding:"1rem"}}>
                  <div style={{fontSize:"13px", fontWeight:"500", color:"#1a1a1a", marginBottom:"0.75rem"}}>Your suggested exit plan:</div>
                  {generateExitPlan().map((rung, i) => (
                    <div key={i} style={{display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:"1px solid rgba(0,0,0,0.06)", fontSize:"14px"}}>
                      <span style={{color:"#6b6b6b"}}>Sell {rung.pct}% at</span>
                      <span style={{fontWeight:"500", color:"#1a6b4a"}}>${rung.price}</span>
                    </div>
                  ))}
                  <div style={{display:"flex", justifyContent:"space-between", padding:"6px 0", fontSize:"14px"}}>
                    <span style={{color:"#6b6b6b"}}>Moon bag (hold)</span>
                    <span style={{fontWeight:"500", color:"#1a1a1a"}}>{wizard.moon_bag_pct}%</span>
                  </div>
                </div>
              )}
              <div style={{display:"flex", gap:"8px"}}>
                <button onClick={saveExitPlan} disabled={wizardSaving || !wizard.low_target || !wizard.high_target} style={{flex:1, padding:"12px", background:"#1a6b4a", color:"#fff", border:"none", borderRadius:"8px", fontSize:"14px", fontWeight:"500", cursor:"pointer"}}>{wizardSaving ? "Saving..." : "Save exit plan"}</button>
                <button onClick={() => setShowWizard(false)} style={{padding:"12px 20px", background:"transparent", border:"1px solid rgba(0,0,0,0.12)", borderRadius:"8px", fontSize:"14px", cursor:"pointer"}}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f4f1eb', fontFamily: 'system-ui, sans-serif' },
  loadingPage: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f1eb' },
  loadingText: { fontSize: '16px', color: '#6b6b6b' },
  nav: { background: "#fff", borderBottom: "1px solid rgba(0,0,0,0.08)", padding: "0 2rem", height: "60px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "relative", flexWrap: "wrap" },
  logo: { fontFamily: 'Georgia, serif', fontSize: '18px', color: '#1a1a1a', textDecoration: 'none' },
  logoAccent: { color: '#1a6b4a' },
  navRight: { display: "flex", alignItems: "center", gap: "8px", flexWrap: "nowrap", overflow: "hidden" },
  navUser: { fontSize: '14px', color: '#6b6b6b' },
  tierBadge: { fontSize: '11px', padding: '3px 10px', borderRadius: '99px', background: '#e8f5ef', color: '#1a6b4a', fontWeight: '500', textTransform: 'capitalize' },
  logoutBtn: { fontSize: '13px', color: '#6b6b6b', background: 'transparent', border: 'none', cursor: 'pointer' },
  content: { maxWidth: '860px', margin: '0 auto', padding: '2rem' },
  upgradeBanner: { background: '#e8f5ef', border: '1px solid rgba(26,107,74,0.2)', borderRadius: '10px', padding: '1rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', marginBottom: '1.5rem', fontSize: '14px', color: '#1a6b4a', flexWrap: 'wrap' },
  upgradeBannerBtn: { background: '#1a6b4a', color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 16px', fontSize: '13px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap' },
  metrics: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '1.5rem' },
  metric: { background: '#faf9f6', borderRadius: '12px', padding: '1rem', border: '1px solid rgba(0,0,0,0.10)', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' },
  metricLabel: { fontSize: '11px', fontWeight: '500', color: '#6b6b6b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px' },
  metricValue: { fontSize: '24px', fontWeight: '500', color: '#1a1a1a' },
  metricSub: { fontSize: '11px', color: '#9b9b9b', marginTop: '3px' },
  tabs: { display: 'flex', gap: '4px', marginBottom: '1rem', background: '#fff', padding: '4px', borderRadius: '10px', border: '1px solid rgba(0,0,0,0.06)', width: 'fit-content' },
  tab: { padding: '8px 16px', borderRadius: '8px', border: 'none', background: 'transparent', fontSize: '14px', color: '#6b6b6b', cursor: 'pointer' },
  tabActive: { background: '#1a6b4a', color: '#fff' },
  section: { background: '#faf9f6', borderRadius: '16px', padding: '1.5rem', border: '1px solid rgba(0,0,0,0.10)', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' },
  sectionHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' },
  sectionTitle: { fontSize: '16px', fontWeight: '500', color: '#1a1a1a', margin: 0 },
  addBtn: { fontSize: '13px', color: '#1a6b4a', textDecoration: 'none', fontWeight: '500' },
  holdingRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid rgba(0,0,0,0.06)' },
  holdingLeft: { display: 'flex', alignItems: 'center', gap: '12px' },
  coinBadge: { width: '40px', height: '40px', borderRadius: '50%', background: '#e8f5ef', color: '#1a6b4a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '500' },
  holdingName: { fontSize: '14px', fontWeight: '500', color: '#1a1a1a' },
  holdingDetail: { fontSize: '12px', color: '#6b6b6b', marginTop: '2px' },
  holdingRight: { textAlign: 'right' },
  holdingValue: { fontSize: '15px', fontWeight: '500', color: '#1a1a1a' },
  holdingGain: { fontSize: '12px', marginTop: '2px' },
  exitRow: { marginBottom: '1rem' },
  exitHeader: { display: 'flex', justifyContent: 'space-between', marginBottom: '6px' },
  exitLabel: { fontSize: '14px', color: '#1a1a1a' },
  exitPct: { fontSize: '12px', color: '#6b6b6b' },
  progressBar: { height: '6px', background: '#f4f1eb', borderRadius: '99px', overflow: 'hidden' },
  progressFill: { height: '100%', background: '#1a6b4a', borderRadius: '99px', transition: 'width 0.3s' },
  empty: { fontSize: '14px', color: '#6b6b6b' },
  link: { color: '#1a6b4a', textDecoration: 'none' },
  upgradeBox: { background: '#f4f1eb', borderRadius: '12px', padding: '2rem', textAlign: 'center' },
  upgradeText: { fontSize: '15px', color: '#6b6b6b', marginBottom: '1rem' },
  upgradeBtn: { display: 'inline-block', background: '#1a6b4a', color: '#fff', padding: '12px 24px', borderRadius: '8px', textDecoration: 'none', fontSize: '14px', fontWeight: '500', border: 'none', cursor: 'pointer' },
  aiNote: { fontSize: '13px', color: '#6b6b6b', marginBottom: '1rem' },
  aiSuggestions: { display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '1rem' },
  suggestion: { fontSize: '12px', padding: '6px 12px', borderRadius: '99px', border: '1px solid rgba(0,0,0,0.12)', background: 'transparent', color: '#6b6b6b', cursor: 'pointer' },
  aiInput: { width: '100%', padding: '12px 14px', border: '1px solid rgba(0,0,0,0.12)', borderRadius: '8px', fontSize: '14px', fontFamily: 'system-ui, sans-serif', color: '#1a1a1a', outline: 'none', boxSizing: 'border-box', resize: 'vertical' },
  btn: { width: '100%', padding: '12px', background: '#1a6b4a', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', marginTop: '0.75rem' },
  aiAnswer: { marginTop: '1.5rem', padding: '1.25rem', background: '#f4f1eb', borderRadius: '12px' },
  aiAnswerLabel: { fontSize: '11px', fontWeight: '500', color: '#1a6b4a', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '0.75rem' },
  aiAnswerText: { fontSize: '14px', color: '#1a1a1a', lineHeight: '1.7', whiteSpace: 'pre-wrap' },
  aiDisclaimer: { fontSize: '11px', color: '#9b9b9b', marginTop: '1rem', lineHeight: '1.5' }
};
